import { FormState } from "../DataTypes/storeTypes";
import * as moment from "moment";

export class DisplayHelper {
    static getFormStateDisplayName(formState: FormState): string {
        switch (formState) {
            case FormState.Saved:
                return "Saved";
            case FormState.Saving:
                return "Saving";
            default:
                return "";
        }
    }

    static toShortDateString(date: string) {
        if (!date) {
            return false;
        }

        return new Date(date).toLocaleDateString();
    }
}
